import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { DIRECTION_FLIGHT, DIRECTION_ARRIVE, DEPARTURE, RETURN }
  from 'components/components/booking/utils/FlightConstants';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlightHelper from 'components/common/helpers/FlightHelper';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import Select from 'react-select';

const selectCustomStyles = {
  control: () => ({
    background: 'transparent',
    display: 'flex',
    width: '250px'
  }),
};

class SummaryFlights extends Component {

  trans = (key, prefix = "content.dashboard") => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  getFlightRowContent = (flightObject, info, flightTypeDirection) => {
    if (flightObject == null) {
      return null;
    }
    var flightHelper = new FlightHelper(flightObject, this.props.locale, flightTypeDirection);
    if (this.props.isSummary) {
      var styleCss = { padding: '0px', margin: '20px 0px 10px 0px', border: '0px' };
    } else {
      var styleCss = { padding: '0px', margin: '0px 0px 15px 0px', border: '0px' };
    }

    var showArrivalCommunicate = this.props.arrivalCommunicate && flightObject.is_arrival;

    if (this.props.isSummary) {
      var citiesOptions = [];
      for (var i = 0; i < this.props.cities.length; i++) {
        var n = this.props.cities[i].name;
        citiesOptions.push({
          label: n == 'inne' ? this.trans('otherCity', 'content.bookingStep4.summary') : n,
          value: n,
        })
      }
    }

    return (
      <React.Fragment>
        <li className="list-summary__item">
          <div className="list-summary__header">
            <div className="text-bold">{flightHelper.getLabel()}</div>
            <div>{flightHelper.getFlightDate()}</div>
          </div>

          <div className="list-summary__desc">
            <FontAwesomeIcon
              icon={['fas', 'map-marker-alt']}
              color="#ccc"
            />
            <div>{info}</div>
            {showArrivalCommunicate &&
              <div>
                <p style={{ fontSize: '14px' }}>{this.props.arrivalCommunicate}</p>
              </div>
            }
          </div>

        </li>
        {(this.props.isSummary && flightObject.is_arrival) &&
          <li className="list-summary__item">
            <div className="list-summary__header">
              <div className="text-bold">
                {this.trans('selectCity', 'content.bookingStep4.summary')}
              </div>
            </div>

            <div className="list-summary__desc">
              <Select
                placeholder={this.trans('selectCityPlaceholder', 'content.bookingStep4.summary')}
                onChange={this.handleChangeCity}
                options={citiesOptions}
                value={citiesOptions.find(({ value, label }) => value === this.props.city)}
                styles={selectCustomStyles}
                isSearchable
              />
            </div>
          </li>
        }
      </React.Fragment>
    );
  }

  timePartial(flightTime, direction, renderOnlyDirection) {
    if (direction === renderOnlyDirection) {
      return (
        <div className="list-flights__time">{flightTime}</div>
      );
    } else {
      return null;
    }
  }

  handleChangeCity = (cityData) => {
    this.props.setBookingCity(cityData.value);
  }

  render() {
    const { differentReturnAddress, departureFlight, returnFlight, cities, city,
      departureAddress, returnAddress, departureInfo, returnInfo } = this.props;
    var objectAddressReturn = null;
    if (returnFlight && !differentReturnAddress) {
      objectAddressReturn = departureAddress;
    } else {
      objectAddressReturn = returnAddress;
    }

    var ulClass = classNames(
      'list-summary',
      { 'list-summary--cell': this.props.isDashboard }
    );
    return (
      <ul className={ulClass}>
        {this.getFlightRowContent(departureFlight, departureInfo, DEPARTURE)}
        {this.getFlightRowContent(returnFlight, returnInfo, RETURN)}
        <li className="list-summary__item list-summary__item--adults">
          <ul style={{ marginLeft: '30px' }}>
            {this.props.adultsNumber > 0 && (
              <React.Fragment>
                <li>
                  <span className="list-summmary__label">{this.trans('adults', 'content.common')}:{' '}</span>
                  <span>{this.props.adultsNumber}</span>{' '}
                </li>
              </React.Fragment>
            )}
            {this.props.childrenNumber > 0 && (
              <React.Fragment>
                <li>
                  <span className="list-summmary__label">{this.trans('kids', 'content.common')}:</span>{' '}
                  <span>{this.props.childrenNumber}</span>
                </li>
              </React.Fragment>
            )}
            {this.props.seniorsNumber > 0 && (
              <React.Fragment>
                <li>
                  <span className="list-summmary__label">{this.trans('seniors', 'content.common')}:</span>{' '}
                  <span>{this.props.seniorsNumber}</span>
                </li>
              </React.Fragment>
            )}
            {this.props.teenagersNumber > 0 && (
              <React.Fragment>
                <li>
                  <span className="list-summmary__label">{this.trans('teenagers', 'content.common')}:</span>{' '}
                  <span>{this.props.teenagersNumber}</span>
                </li>
              </React.Fragment>
            )}
            {this.props.studentsNumber > 0 && (
              <React.Fragment>
                <li>
                  <span className="list-summmary__label">{this.trans('students', 'content.common')}:</span>{' '}
                  <span>{this.props.studentsNumber}</span>
                </li>
              </React.Fragment>
            )}
          </ul>
        </li>

        {this.props.isDashboard &&
          <li className="list-summary__item list-summary__item--price">
            <FontAwesomeIcon
              icon={['fas', 'credit-card']}
              color="#ccc"
            />
            <span className="list-summmary__label">
              {this.trans('price', 'content.common')}:
            </span>
            {' '}
            {parseFloat(this.props.price)}
            {' '}
            <span className="currency">
              {this.trans('currency', 'content.common')}
            </span>
            {' '}

            {this.props.paymentToDriver
              ?
              (<em>({this.trans('payToDriver')})</em>)
              :
              (<em>({this.trans('payWithCard')})</em>)
            }
          </li>
        }
      </ul>
    );
  }
}

export default SummaryFlights;

SummaryFlights.propTypes = {
  adultsNumber: PropTypes.number,
  childrenNumber: PropTypes.number,
  departureFlight: PropTypes.object,
  returnFlight: PropTypes.object,
  returnAddress: PropTypes.object,
  departureAddress: PropTypes.object,
  differentReturnAddress: PropTypes.bool,
};
